import { t } from 'i18next'
import * as yup from 'yup'

export const nameSchema = yup.object({
    objectName: yup
        .string()
        .trim()
        .required(t('blank-errors'))
        .max(255, t('invalid-field'))
        .matches(/^[^<>:"/\\|?*]+$/, t('invalid-field')),
})
